<template>
  <v-app>
    <supplier-type-setup
      :dialog="supplierTypeDialog"
      :data="data"
      @update:dialog="supplierTypeDialog = $event"
    />
    <v-container fluid>
      <template v-if="$insertAccess($route.fullPath)">
        <base-card
          :title="isEntryMode ? 'Add Supplier' : 'Update Supplier'"
          icon="mdi-truck-outline"
          :v-card-text-class="'pa-2'"
          :loading-allowed="false"
        >
        <v-form @submit.prevent="submit">
          <v-row>
            <v-col cols="12">
              <v-card elevation="0" border rounded="lg" class="pa-3">
                <div class="d-flex align-center mb-4">
                  <v-avatar color="primary" variant="tonal" size="36" class="me-2">
                    <v-icon size="20">mdi-information-outline</v-icon>
                  </v-avatar>
                  <div>
                    <div class="text-subtitle-1 font-weight-medium">Supplier Information</div>
                    <div class="text-caption text-medium-emphasis">Provide the supplier's company and business information.</div>
                  </div>
                </div>
                    <v-row  class="py-2">
                      <v-col lg="4" md="4" cols="12">
                        <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"

                          v-model="supplier_name.value.value"
                          :error-messages="supplier_name.errorMessage.value"
                          clearable
                        >
                          <template #label>
                            Supplier Company Name
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-text-field>
                        <v-text-field
                          label="Owner Name"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"

                          v-model="company_name.value.value"
                          :error-messages="company_name.errorMessage.value"
                          clearable
                        ></v-text-field>
                        <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"

                          v-model="supplier_email.value.value"
                          :error-messages="supplier_email.errorMessage.value"
                          clearable
                        >
                          <template #label>
                            Email Address
                          </template>
                        </v-text-field>
                        <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"

                          v-model="supplier_mobile.value.value"
                          :error-messages="supplier_mobile.errorMessage.value"
                          clearable
                        >
                          <template #label>
                            Mobile Number
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col lg="4" md="4" cols="12">
                        <v-autocomplete
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"

                          v-model="supplier_country_id.value.value"
                          :error-messages="
                            supplier_country_id.errorMessage.value
                          "
                          clearable
                          :items="getInvCountryList"
                          :item-title="(item) => `${item.name}`"
                          autocomplete="off"
                          item-value="id"
                          :menu-props="{ width: 300, contentClass: 'my-custom-dropdown'}"
                          @update:modelValue="getInvCountryList"
                        >
                          <template #label>
                            Supplier Country
                          </template>
                          <template v-slot:selection="{ props, item }">
                              <div class="d-flex align-center noto-color-emoji-regular"
                                  v-bind="props"
                                  color="primary"
                                  variant="tonal"
                              >
                              <span class="mr-1">{{ item.raw.emoji }}</span>
                              {{ item.raw.name }}
                            </div>
                          </template>
                          <template v-slot:item="{ props, item }">
                            <v-list-item v-bind="props" v-slot=""  :title="null">
                                <div class="d-flex align-center noto-color-emoji-regular" style="width: 100%;">
                                    <span class="mr-2 text-lg">{{ item.raw.emoji }}</span>
                                    <div class="flex-grow-1">
                                        <span>{{ item.raw.name }}</span>
                                        <small v-if="item.raw.native" class="text-grey">
                                            ({{ item.raw.native }})
                                        </small>
                                    </div>
                                    <div class="text-grey text-caption">
                                        +{{ item.raw.phonecode }}
                                    </div>
                                </div>
                            </v-list-item>
                          </template>
                        </v-autocomplete>

                        <v-autocomplete
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"

                          v-model="supplier_type_id.value.value"
                          :error-messages="supplier_type_id.errorMessage.value"
                          clearable
                          :items="getSupplierTypeList"
                          :item-title="(item) => `${item.code} - ${item.name}`"
                          autocomplete="off"
                          item-value="id"
                          @update:modelValue="getSupplierTypeList"

                            :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                          <template #label>
                            Supplier Type
                            <span class="text-red-accent-4">*</span>
                          </template>

                          <template v-slot:append-inner>
                            <v-slide-x-reverse-transition mode="out-in">
                              <v-icon
                                @mousedown.stop="openAddSupplierType"
                                icon="mdi-plus-circle-outline"
                                color="primary"
                                size="24"
                                class="cursor-pointer"
                              ></v-icon>
                            </v-slide-x-reverse-transition>
                          </template>
                        </v-autocomplete>

                        <v-text-field
                          label="Supplier Address"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"

                          v-model="supplier_address.value.value"
                          :error-messages="supplier_address.errorMessage.value"
                          clearable
                        ></v-text-field>

                        <v-autocomplete
                          label="Requisition"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          v-model="supplier_bank_ids.value.value"
                          :items="getLcBankList"
                          :item-title="(item) => `${item.name} - ${item.bank_name || 'N/A'} - ${item.account_no || 'N/A'}`"
                          item-value="id"
                          :error-messages="supplier_bank_ids.errorMessage.value"
                          autocomplete="off"
                          multiple
                          chips
                          clearable

                            :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                          <template #label>
                            Supplier Banks
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-autocomplete>

                        <v-file-input
                            variant="outlined"
                            density="compact"
                            label="Supplier Document Attachment"
                            prepend-inner-icon="mdi-attachment"
                            prepend-icon=""
                            bg-color="grey-lighten-4"
                            chips
                            show-size
                            multiple
                        ></v-file-input>
                      </v-col>

                      <v-col lg="4" md="4" cols="12">
                        <v-autocomplete
                          label="Dealing Person"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"

                          v-model="dealing_person_id.value.value"
                          :error-messages="dealing_person_id.errorMessage.value"
                          clearable
                          :items="getHrmEmployeeList"
                          :item-title="(item) => `${item.code} - ${item.name}`"
                          autocomplete="off"
                          item-value="id"

                            :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        </v-autocomplete>

                        <v-text-field
                          label="BIN No."
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"

                          v-model="supplier_bin.value.value"
                          :error-messages="supplier_bin.errorMessage.value"
                          clearable
                        >
                          <!-- <template #label>
                            BIN No.
                            <span class="text-red-accent-4">*</span>
                          </template> -->
                        </v-text-field>

                        <v-text-field
                          label="VAT Number"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"

                          v-model="supplier_vat.value.value"
                          :error-messages="supplier_vat.errorMessage.value"
                          clearable
                        ></v-text-field>

                        <v-text-field
                          label="TIN No."
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"

                          v-model="supplier_tin.value.value"
                          :error-messages="supplier_tin.errorMessage.value"
                          clearable
                        ></v-text-field>

                        <input
                          v-model="supplier_id.value.value"
                          type="hidden"
                        />

                        <v-file-input
                            v-model="selectedImage"
                            label="Supplier Image/Logo"
                            accept="image/*"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            show-size
                            @input="previewImage"
                            @click:clear="clearImage"
                            prepend-inner-icon="mdi-camera"
                            prepend-icon=""
                            persistent-hint
                            hint="Image must be exactly 120px × 120px"
                            class="ellipsis-filename"
                        ></v-file-input>
                        <v-img :src="preview" cover class="preview-image"></v-img>
                      </v-col>
                    </v-row>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-card elevation="0" border rounded="lg" class="pa-3">
                <div class="d-flex align-center mb-4">
                  <v-avatar color="primary" variant="tonal" size="36" class="me-2">
                    <v-icon size="20">mdi-account-group-outline</v-icon>
                  </v-avatar>
                  <div>
                    <div class="text-subtitle-1 font-weight-medium">Contact Person Information</div>
                    <div class="text-caption text-medium-emphasis">Add one or more supplier contact persons.</div>
                  </div>
                </div>
                <div v-if="!contacts.length" class="text-center py-8">
                  <v-icon size="64" color="grey-darken-1" class="mb-2">
                    mdi-account-group-outline
                  </v-icon>
                  <div class="text-body-2 text-medium-emphasis mb-4">
                    No contact person added yet
                  </div>
                  <v-btn @click="addContactRow" variant="tonal" color="primary">
                    <v-icon color="info" icon="mdi-plus" size="large" class="mr-2"></v-icon>
                    Add Contact Info
                  </v-btn>
                </div>

                <template v-else>
                  <div style="max-height: 400px;" class="overflow-x-auto d-flex flex-column flex-nowrap">
                    <v-row
                    v-for="(contact, index) in contacts"
                    :key="index"
                    class="d-flex flex-nowrap"
                    align="start"
                    dense
                  >
                    <v-col cols="12" sm="4" md="3">
                        <v-text-field
                          v-model="contact.name"
                          label="Name"
                          hide-details="auto"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          class="ma-0"
                          @blur="
                            validateContactField(index, 'name', contact.name)
                          "
                        ></v-text-field>
                        <v-text-field
                            v-model="contact.email"
                            label="Email"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            class="ma-0"
                            @blur="
                              validateContactField(index, 'email', contact.email)
                            "
                        />
                      </v-col>

                    <v-col cols="12" sm="4" md="3">
                        <v-text-field
                          v-model="contact.mobile"
                          label="Mobile"
                          hide-details="auto"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          class="ma-0"
                          @blur="
                            validateContactField(
                              index,
                              'mobile',
                              contact.mobile
                            )
                          "
                        ></v-text-field>
                      </v-col>
                    <v-col cols="12" sm="4" md="3">
                        <v-text-field
                          v-model="contact.designation"
                          label="Designation"
                          hide-details="auto"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          class="ma-0"
                          @blur="
                            validateContactField(
                              index,
                              'designation',
                              contact.designation
                            )
                          "
                        />
                      </v-col>

                    <v-col cols="12" sm="4" md="3">
                        <v-text-field
                          v-model="contact.department"
                          label="Department"
                          hide-details="auto"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          class="ma-0"
                          @blur="
                            validateContactField(
                              index,
                              'department',
                              contact.department
                            )
                          "
                        />
                      </v-col>
                    <v-col cols="12" md="1" class="d-flex flex-column align-center justify-center">
                      <v-btn
                          icon="mdi-delete-outline"
                          size="small"
                          color="error"
                          variant="text"
                          @click="removeContactRow(index)"
                      ></v-btn>
                      <v-btn
                          v-if="index === contacts.length - 1"
                          icon="mdi-plus"
                          size="small"
                          color="info"
                          variant="text"
                          @click="addContactRow"
                      ></v-btn>
                    </v-col>
                    <v-divider v-if="contacts.length > 1 && index !== contacts.length - 1"></v-divider>
                    </v-row>
                  </div>
                </template>
              </v-card>
            </v-col>
          </v-row>

          <v-divider class="mt-4"></v-divider>
          <v-card-actions>
            <v-row>
              <v-col cols="12" md="8">
                <v-textarea
                  v-model="remarks.value.value"
                  :error-messages="remarks.errorMessage.value"
                  label="Description"
                  maxlength="500"
                  rows="3"
                  density="compact"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  clearable
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="4">
                <div class="d-flex justify-end ga-2">
                  <v-btn
                    color="grey-darken-1"
                    variant="flat"
                    prepend-icon="mdi-content-save-outline"
                    type="button"
                    @click="submitForm(0)"
                  >
                    Draft
                  </v-btn>
                  <v-btn
                    color="primary"
                    variant="flat"
                    prepend-icon="mdi-content-save-check-outline"
                    type="button"
                    @click="submitForm(1)"
                  >
                    Save
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>

        </v-form>
        </base-card>
      </template>
    </v-container>
  </v-app>
</template>

<script>
import BaseCard from "@/components/utils/baseCard.vue";
import supplierTypeSetup from "@/components/module/inventory/supplierManagement/supplierTypeSetup.vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, reactive } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";
import { fileServerUrl } from "@/store/api";

const DEFAULT_IMAGE = "/src/assets/no_preview.jpeg";

export default {
  components: {
    BaseCard,
    supplierTypeSetup,
  },
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    contactPersonInfo: [0],
    bankInfo: [0],
    loading: false,
    search: "",
    dialog: false,
    supplierTypeDialog: false,
    isEntryMode: true,
    unitDialog: false,
    data: {},
    preview: "/src/assets/no_preview.jpeg",
  }),
  watch: {},
  created() {
    // if (this.$store.getters.getSupplierTypeList.length == 0) {
      this.loading = true;
      this.$store.dispatch("getSupplierTypeList").then((response) => {
        this.loading = false;
      });
    // }

    // if (this.$store.getters.getLcBankList.length == 0) {
      this.$store.dispatch("getLcBankList");
    // }

    // if (this.$store.getters.getHrmEmployeeList.length === 0) {
      this.loading = true;
      this.$store.dispatch('getHrmEmployeeList').then((response) => {
        this.loading = false;
      })
    // }

    // if (this.$store.getters.getInvCountryList.length == 0) {
      this.loading = true;
      this.$store.dispatch("getInvCountryList").then((response) => {
        this.loading = false;
      });
    // }
  },
  computed: {
    getSupplierTypeList() {
      let data = this.$store.getters.getSupplierTypeList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },

    getLcBankList() {
      let data = this.$store.getters.getLcBankList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },

    getInvCountryList() {
      let country = this.$store.getters.getInvCountryList;
      if (country.length > 0) {
        return country;
      }
    },

    getHrmEmployeeList() {
      let employee = this.$store.getters.getHrmEmployeeList;
      return employee;

    },

    editingSupplier() {
      return this.$store.getters.getEditingSupplier;
    },
  },
  methods: {
    openAddSupplierType() {
      this.data = {
        id: "",
        name: "",
        code: "",
        remarks: "",
        status: 1,
      };
      this.supplierTypeDialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.supplierTypeDialog = false;
      this.data = {};
    },
    resetForm() {
      this.data = {};
      this.preview = "/src/assets/no_preview.jpeg";
      this.selectedImage = null;
    },
    previewImage: function (event) {
      this.selectedImage = event.target.files[0];
      const input = event.target;
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      } else {
        this.preview = "/src/assets/no_preview.jpeg";
      }
    },
    clearImage() {
      this.preview = "/src/assets/no_preview.jpeg";
    },
  },

  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        supplier_type_id: yup.number().positive().integer().required().label("Supplier Type Name"),
        supplier_name: yup.string().min(1).max(255).required().trim().label("Supplier Name"),

        supplier_tin: yup.string().nullable().min(1).max(255).trim().label("TIN"),
        company_name: yup.string().min(1).max(255).nullable().trim().label("Customer Name"),

        supplier_vat: yup.string().nullable().min(1).max(15).label("VAT"),
        supplier_address: yup.string().nullable().min(1).max(255).label("Address"),
        description: yup.string().nullable().max(300).label("Description"),
      }),
    });

    const supplier_type_id = useField("supplier_type_id");
    const dealing_person_id = useField("dealing_person_id");
    const supplier_bank_ids = useField("supplier_bank_ids");
    const supplier_name = useField("supplier_name");
    const supplier_email = useField("supplier_email");
    const supplier_tin = useField("supplier_tin");
    const company_name = useField("company_name");
    const supplier_country_id = useField("supplier_country_id");
    const supplier_mobile = useField("supplier_mobile");
    const supplier_vat = useField("supplier_vat");
    const supplier_bin = useField("supplier_bin");
    const supplier_address = useField("supplier_address");
    const description = useField("description");
    const remarks = useField("remarks");
    const status = useField("status");
    const supplier_id = useField("supplier_id");

    const currentStatus = ref("");

    const contacts = ref([
      {
        name: "",
        mobile: "",
        email: "",
        designation: "",
        department: "",
      },
    ]);

    const contactErrors = reactive({});
    const errorMessages = ref("");
    const loading = ref("");
    const selectedImage = ref(null);
    const preview = ref(DEFAULT_IMAGE);
    const isEntryMode = ref(true);

    const store = useStore();
    const router = useRouter();

    const addContactRow = () => {
      contacts.value.push({
        name: "",
        mobile: "",
        email: "",
        designation: "",
        department: "",
      });
    };

    const removeContactRow = (index) => {
      if (confirm("Are you sure?")) {
        contacts.value.splice(index, 1);
        // Remove validation errors for the removed contact
        delete contactErrors[index];
        // Re-index the errors
        const newErrors = {};
        Object.keys(contactErrors).forEach((key) => {
          const idx = parseInt(key);
          if (idx > index) {
            newErrors[idx - 1] = contactErrors[key];
          } else if (idx < index) {
            newErrors[idx] = contactErrors[key];
          }
        });
        Object.keys(contactErrors).forEach((key) => delete contactErrors[key]);
        Object.assign(contactErrors, newErrors);
      }
    };

    const submitForm = (status) => {
      currentStatus.value = status;
      submit();                       
    };

    const submit = handleSubmit((values) => {
      // if (!validateAllContacts()) {
      //   toast.error("Please fix contact validation errors before submitting");
      //   return;
      // }

      const contactsData = contacts.value || [];

      const statusValue = currentStatus.value ? 1 : 0;

      const formData = new FormData();

      Object.keys(values).forEach((key) => {
        if (values[key] !== undefined && values[key] !== null) {
          if (key === "supplier_bank_ids") formData.append(key, JSON.stringify(values[key] ?? []));
          else formData.append(key, values[key]);
        }else{
            formData.append(key,'');
        }
      }); 

      formData.append("contacts", JSON.stringify(contactsData));
      formData.append("status", statusValue);

      if (selectedImage.value) {
        formData.append("image", selectedImage.value);
      }

      // for (const [key, value] of formData.entries()) {
      //   console.log(`${key}:`, value);
      // }

      loading.value = true;
      store
        .dispatch("saveUpdateSupplier", formData)
        .then((response) => {
          resetForm();
          loading.value = false;
          toast.success(response.data.message, {
            timeout: 3000,
          });
          setTimeout(() => {
            router.push({ name: "supplier-list" });
          }, 2000);
        })
        .catch((error) => {
          loading.value = false;
          console.error("Error:", error);
          toast.error(error.response?.data?.message || "An error occurred");
        });
    });

    return {
      submit,
      submitForm,
      supplier_type_id,
      dealing_person_id,
      supplier_name,
      supplier_email,
      supplier_tin,
      company_name,
      supplier_country_id,
      supplier_bank_ids,
      supplier_mobile,
      contacts,
      addContactRow,
      removeContactRow,
      supplier_vat,
      supplier_bin,
      supplier_address,
      description,
      remarks,
      status,
      errorMessages,
      selectedImage,
      preview,
      isEntryMode,
      supplier_id,
      resetForm,
      loading,
      contactErrors,
    };
  },

  mounted() {
    if (this.$store.getters.getEditingSupplier) {
      this.isEntryMode = false;
      const supplier = this.$store.getters.getEditingSupplier;
      this.supplier_id.value.value = supplier.id;
      this.supplier_name.value.value = supplier.supplier_name;
      this.supplier_email.value.value = supplier.supplier_email;
      this.supplier_tin.value.value = supplier.supplier_tin;
      this.company_name.value.value = supplier.company_name;
      this.supplier_country_id.value.value = supplier.supplier_country_id;
      this.supplier_mobile.value.value = supplier.supplier_mobile;
      this.supplier_vat.value.value = supplier.supplier_vat;
      this.supplier_bin.value.value = supplier.supplier_bin;
      this.supplier_address.value.value = supplier.supplier_address;
      this.description.value.value = supplier.description;
      this.remarks.value.value = supplier.remarks;
      this.supplier_type_id.value.value = supplier.supplier_type_id;
      this.status.value.value = supplier.status == 1 ? true : false;
      this.contacts = supplier.contacts || [
            {
            name: "",
            mobile: "",
            email: "",
            designation: "",
            department: "",
            },
        ];

      this.supplier_bank_ids.value.value = supplier?.supplier_banks?.map((bank) => bank?.bank_id);

      if (supplier.image) {
        this.preview = supplier.image
          ? fileServerUrl + supplier.image
          : "/src/assets/no_preview.png";
      } else {
        this.preview = DEFAULT_IMAGE;
      }
    } else {
      this.supplier_id.value.value = "";
      this.isEntryMode = true;
    }
  },
  beforeUnmount() {
    // Clear the editing customer from Vuex when component is destroyed
    this.$store.commit("clearEditingSupplier");
  },
};
</script>
